export default __webpack_public_path__ + "static/media/Rundstav Teak.39fcd230.jpg";